import { IGroupTotalEmissions } from '../services/group/group.model'
import { formatEmissionAmount } from './emission-summary-utils'

// A group's total for the selected report period. The API sends it in tCO2e on both Scope 2 bases,
// from the same breakdown Analytics uses; which basis is shown follows the organisation's default,
// exactly as the dashboard does. The two only differ for a Scope 2 group.

export const getGroupTotalTonnes = (
  totalEmissions: IGroupTotalEmissions | undefined,
  defaultMarketBased: boolean | undefined,
): number | null => {
  if (!totalEmissions) return null
  const value = defaultMarketBased === true ? totalEmissions.marketBased : totalEmissions.locationBased
  return typeof value === 'number' && !Number.isNaN(value) ? value : null
}

// Scale-aware like every other emission figure (kg below a tonne). A flat zero reads in tonnes.
export const formatGroupTotal = (tonnes: number | null): string | null => {
  if (tonnes == null) return null
  return tonnes === 0 ? '0.00 tCO₂e' : formatEmissionAmount(tonnes * 1000)
}

// Scope 2 is the only scope with two answers, so it is the only one that says which it is showing.
export const getGroupTotalBasisLabel = (scope: string | undefined, defaultMarketBased: boolean | undefined): string | null => {
  if (String(scope ?? '').replace(/^Scope\s+/i, '').trim() !== '2') return null
  return defaultMarketBased === true ? 'Market-based' : 'Location-based'
}
